export default __webpack_public_path__ + "static/media/large.23cbe29c.jpg";